import { Feature } from './feature';

enum ProductGroup {
  TRUE_PLATFORM = 'true.platform',
  TEST_CREATION = 'test.creation',
  TEST_EXECUTION = 'test.execution',
  TESTOPS = 'test.operation',
  ADVANCED_WEB_TESTING = 'advanced.web.testing',
}

const getGroupFeature = (group: ProductGroup, selfServeOnly?: boolean): Array<Feature> => {
  switch (group) {
    case ProductGroup.TRUE_PLATFORM:
      return selfServeOnly
        ? [Feature.TRUE_TEAM]
        : [
          Feature.TRUE_TEAM,
          Feature.TRUE_ENTERPRISE,
        ];
    case ProductGroup.TEST_CREATION:
      return selfServeOnly
        ? [Feature.PER_USER_KSE, Feature.FLOATING_KSE]
        : [
          Feature.KSE,
          Feature.UNLIMITED_KSE,
          Feature.PER_USER_KSE_OFFLINE,
          Feature.PER_USER_KSE,
          Feature.FLOATING_KSE,
        ];
    case ProductGroup.TEST_EXECUTION:
      return selfServeOnly
        ? [
          Feature.UNLIMITED_ENGINE,
          Feature.TESTCLOUD_SESSION_WEB_DESKTOP,
          Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
          Feature.TESTCLOUD_SESSION_MOBILE_APP,
          Feature.TESTCLOUD_SESSION_LIVE_TESTING,
        ]
        : [
          Feature.ENGINE,
          Feature.FLOATING_ENGINE,
          Feature.UNLIMITED_ENGINE,
          Feature.UNLIMITED_ENGINE_OFFLINE,
          Feature.TESTCLOUD_MINUTE,
          Feature.TESTCLOUD_SESSION_WEB,
          Feature.TESTCLOUD_FREE_TRIAL,
          Feature.TESTCLOUD_SESSION_WEB_DESKTOP,
          Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
          Feature.TESTCLOUD_SESSION_MOBILE_APP,
          Feature.TESTCLOUD_SESSION_PRIVATE_DEVICE,
          Feature.TESTCLOUD_SESSION_LIVE_TESTING,
        ];
    case ProductGroup.TESTOPS:
      return selfServeOnly ? []
        : [
          Feature.TESTOPS,
          Feature.TESTOPS_BUSINESS,
          Feature.TESTOPS_ENTERPRISE,
          Feature.TESTOPS_PLATFORM,
          Feature.TESTOPS_G3,
        ];
    case ProductGroup.ADVANCED_WEB_TESTING:
      return selfServeOnly ? []
        : [
          Feature.TRUE_TEST,
        ];
    default:
      return [];
  }
};

const getGroupDisplayColor = (group: ProductGroup): string => {
  switch (group) {
    case ProductGroup.TEST_CREATION:
      return '#0F8461';
    case ProductGroup.TEST_EXECUTION:
      return '#43509B';
    case ProductGroup.TESTOPS:
      return '#7232B1';
    default:
      return '';
  }
};
export { ProductGroup, getGroupDisplayColor, getGroupFeature };
